import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "i18n-fe";

// #3588 -- why the Final Class Report is locked for a class, in the server's
// words (badge-counts finalClassLocks: score-common's one definition of
// "current placings", the same one the Mid-Class Report prints on), and the fix
// as a button (docs/adr/0004). `lock` is { reason, groups: [{ division, reason,
// rideIds }] }.
export const PLACE_BUTTON_ANCHOR_ID = "placings-place-anchor";

function whereOf(t, groups) {
  const divisions = groups.map((g) => g.division).filter(Boolean);
  return divisions.length > 0 ? t("placings.finalLocked.inDivisions", { divisions: divisions.join(", ") }) : "";
}

export default function FinalClassLockNotice({ lock, classId }) {
  const { t } = useTranslation("scoreadmin");
  if (!lock) return null;
  // The groups behind the primary reason: those are what to fix first.
  const groups = lock.groups.filter((g) => g.reason === lock.reason);
  const count = groups.reduce((n, g) => n + g.rideIds.length, 0);
  const where = whereOf(t, groups);

  let message;
  let fix;
  switch (lock.reason) {
    case "RIDES_UNFINISHED":
      message = t("placings.finalLocked.ridesUnfinished", { count, where });
      fix = { to: `/classes/${classId}`, label: t("placings.finalLocked.openClass") };
      break;
    case "NEEDS_PLACINGS":
      message = t("placings.finalLocked.needsPlacings", { where });
      fix = { anchor: true, label: t("placings.finalLocked.goToPlace") };
      break;
    case "OUT_OF_DATE_PLACINGS":
      message = t("placings.finalLocked.outOfDate", { count, where });
      fix = { anchor: true, label: t("placings.finalLocked.goToPlace") };
      break;
    default:
      message = t("placings.finalLocked.noRides");
      fix = { to: `/classes/${classId}`, label: t("placings.finalLocked.openClass") };
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }} data-testid="placings-final-locked">
      <Typography variant="body2" color="text.secondary" data-testid="placings-final-locked-reason">
        {message}
      </Typography>
      {fix.to ? (
        <Button size="small" variant="outlined" component={RouterLink} to={fix.to} data-testid="placings-final-locked-fix">
          {fix.label}
        </Button>
      ) : (
        <Button
          size="small"
          variant="outlined"
          data-testid="placings-final-locked-fix"
          onClick={() => {
            const el = document.getElementById(PLACE_BUTTON_ANCHOR_ID);
            el?.scrollIntoView?.({ behavior: "smooth", block: "center" });
            el?.focus?.();
          }}
        >
          {fix.label}
        </Button>
      )}
    </Box>
  );
}
